import { getStaticPathForMakes } from '@cinch-nx/landing-feature-car-reviews-hub'

export const getStaticPaths = getStaticPathForMakes({ requiresPage: false })

export {
  V2GetStaticProps as getStaticProps,
  CarReviewsHubFeature as default,
} from '@cinch-nx/landing-feature-car-reviews-hub'
